export class ChangedHistoryModel {
    public id!: number;
    public orderId!: number;
    public uId!: number;
    public userName!: string;
    public historyContent!: string;
    public orderType!: number;
    public type!: number;
    public createDate!: string;
};

